const rankingItems = [
  { rank: 1, title: '顶流艺人恋情实锤，深夜密会画面曝光', heat: '98.7', change: 'new', tag: '爆' },
  { rank: 2, title: '选秀节目黑幕录音流出，节目组连夜回应', heat: '95.2', change: 'up', tag: '热' },
  { rank: 3, title: '知名导演新片片场事故内幕追踪报道', heat: '91.4', change: 'up', tag: '热' },
  { rank: 4, title: '女星婚变传闻升级，社交平台删光合照', heat: '87.6', change: 'steady', tag: '' },
  { rank: 5, title: '综艺录制现场突发争执，嘉宾翻脸离席', heat: '83.9', change: 'down', tag: '' },
  { rank: 6, title: '年度51吃瓜大赛投票通道正式开启', heat: '79.3', change: 'up', tag: '新' },
  { rank: 7, title: '圈内人士匿名爆料下半年三大巨瓜', heat: '74.8', change: 'new', tag: '爆' },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-accent-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  const getChangeIcon = (change: string) => {
    if (change === 'up' || change === 'new') return 'ri-arrow-up-line text-primary-500';
    if (change === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            实时更新热度排行，不错过任何一个爆款大瓜
          </p>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className={`flex items-center gap-3 md:gap-4 p-4 md:p-5 hover:bg-background-100 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div
                className={`flex-shrink-0 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg text-xs md:text-sm font-bold ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-semibold text-foreground-900 truncate hover:text-primary-500 transition-colors">
                    {item.title}
                  </span>
                  {item.tag && (
                    <span className={`flex-shrink-0 inline-block px-1.5 py-0.5 rounded text-[10px] font-bold ${
                      item.tag === '爆' ? 'bg-primary-100 text-primary-700' : item.tag === '热' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-xs md:text-sm font-semibold text-accent-500">{item.heat}</span>
                <span className="text-xs text-foreground-400">万热度</span>
              </div>
              <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                <i className={`${getChangeIcon(item.change)} text-sm`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}